import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'hemoglobinG', 'hemoglobinMmol',
    'mchPg', 'mchFmol',
    'mchcGhb', 'mchcMmol',
    'mcvUm', 'mcvFl',
    'wbc1000', 'wbc10'
  ]

  convertHemoglobinG()    { this.#convert(this.hemoglobinGTarget,    this.hemoglobinMmolTarget, 0.6206) }
  convertHemoglobinMmol() { this.#convert(this.hemoglobinMmolTarget, this.hemoglobinGTarget,    1 / 0.6206) }

  convertMchPg()   { this.#convert(this.mchPgTarget,   this.mchFmolTarget, 16.11) }
  convertMchFmol() { this.#convert(this.mchFmolTarget, this.mchPgTarget,   1 / 16.11) }

  convertMchcGhb()  { this.#convert(this.mchcGhbTarget,  this.mchcMmolTarget, 0.6206) }
  convertMchcMmol() { this.#convert(this.mchcMmolTarget, this.mchcGhbTarget,  1 / 0.6206) }

  convertMcvUm() { this.#convert(this.mcvUmTarget, this.mcvFlTarget,  1) }
  convertMcvFl() { this.#convert(this.mcvFlTarget, this.mcvUmTarget,  1) }

  convertWbc1000() { this.#convert(this.wbc1000Target, this.wbc10Target,   1) }
  convertWbc10()   { this.#convert(this.wbc10Target,   this.wbc1000Target, 1) }

  #convert(source, dest, factor) {
    const val = parseFloat(source.value)
    dest.value = isNaN(val) ? '' : parseFloat((val * factor).toFixed(4))
  }
}
